// File: src/utils/resolvePhotoUrl.ts
import { getApiBaseUrl } from "../config/api";

/**
 * Converts stored photoUrl values into something the browser can actually load.
 *
 * - If already absolute (http/https) => return as-is
 * - If relative (/uploads/abc.jpg or uploads/abc.jpg) => prefix API base URL
 */
export function resolvePhotoUrl(photoUrl?: string | null): string | null {
  if (!photoUrl) return null;

  const u = photoUrl.toString().trim();
  if (!u) return null;

  // Absolute URL already
  if (/^https?:\/\//i.test(u)) return u;

  const base = getApiBaseUrl();
  if (!base) return u; // fallback

  const p = u.startsWith("/") ? u : `/${u}`;
  return `${base}${p}`;
}